import slide1 from './Images/IMG_0322.JPG';
import slide2 from './Images/IMG_0331.JPG';
import slide3 from './Images/IMG_0334.JPG';
import slide4 from './Images/IMG_0346.JPG';
import slide5 from './Images/IMG_0348.JPG';
import slide6 from './Images/IMG_0364.JPG';

const gallery = {slide1,slide2,slide3,slide4,slide5,slide6};

export default gallery;
